import { render, staticRenderFns } from "./products-combo-index.vue?vue&type=template&id=23117906&"
import script from "./products-combo-index.vue?vue&type=script&lang=js&"
export * from "./products-combo-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23117906')) {
      api.createRecord('23117906', component.options)
    } else {
      api.reload('23117906', component.options)
    }
    module.hot.accept("./products-combo-index.vue?vue&type=template&id=23117906&", function () {
      api.rerender('23117906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stores/products-combo-index.vue"
export default component.exports